/**
 * Reviewer-role SSOT for the frontend. Mirrors backend `utils/team-role.ts`
 * `isReviewerRole`: the legacy 'CLIENT' name is an alias of 'REVIEWER', any case.
 * Use this instead of comparing `teamRole === 'REVIEWER'`.
 */
export function isReviewerRole(role: string | null | undefined): boolean {
  if (!role) return false;
  const upper = role.trim().toUpperCase();
  return upper === 'REVIEWER' || upper === 'CLIENT';
}
